module.exports = __webpack_public_path__ + "static/media/safe.7dfdcf55.png";